




























import { ref, createComponent, Ref, onMounted, computed } from '@vue/composition-api'
import { getUserInfo } from '@/service/common'
import { useStore } from '@/hooks/common'
import IsElectron from 'is-electron'
import {getEnv,parseLocation, removeToken, setToken,removeUserToken} from "@/helpers/common"

export default createComponent({
    setup(prop,setupContext) {
        const store = useStore()
        const userName: Ref<string> = ref('')
        const logOut = () => {           
            removeToken()
            removeUserToken()
            if (IsElectron()) {
                (window as any).Ait.fileSystem.removeAllCookie()
            }
            const url={
                dev:`https://test-4a.wanyol.com/siam/logout?service=${location.origin}/web/public/`,
                test:`https://test-4a.wanyol.com/siam/logout?service=${location.origin}/web/public/`,
                prod:`https://sso.myoas.com/siam/logout?service=${location.origin}/web/public/`
            }
            window.location.href=url[getEnv()] 
            // getUserInfo()
        }
        const env = computed(() => {
            const href = location.href
            if (href.includes('file-system.test.ait.wanyol.com')) {
                return '测试'
            } else if (href.includes('dev-file-system.ait.wanyol.com')) {
                return '开发'
            } else {
                return ''
            }
        })
        const handleDownloadDesktop = () => {
            const downloadAppUrl = window.location.origin + '/desktop/heyTap_ait.zip'
            const link = document.createElement('a')
            link.download = ''
            link.target = '_blank'
            link.href = downloadAppUrl
            link.click()
        }
        onMounted(async () => {
            if (parseLocation()['code']) {
                const token = parseLocation()['code']
                removeToken({ domain: '.ait.wanyol.com' })
                setToken(token)
            }
            const res = await getUserInfo()
            if (res && res.isLogin) {
                const name = res.data.displayName
                const id = res.data.userName
                ;(window as any).userId = id
                userName.value = `${name ? name : '--'}(${id ? id : '--'})`
                store.commit('SET_CURRENT_USER', id)
                if (IsElectron()) {
                    // 上传暂时没有用
                    (window as any).Ait.fileSystem.getUploadList()
                    ;(window as any).Ait.fileSystem.getDbDownloadList()
                }
                const state=setupContext.root.$route.query.state,
                    localUrl=location.origin+location.pathname
                if(state&&localUrl!==decodeURIComponent(state as string).split("?")[0]){
                    window.location.href=decodeURIComponent(state as string)
                }
               
            }
        })
        return {
            userName,
            logOut,
            env,
            handleDownloadDesktop,
        }
    },
})
